import { createFileRoute } from '@tanstack/react-router'
import { AvailableChallengesPage } from '../../components'

const ChallengeSlugPage = () => {
  const { slug } = Route.useParams()
  return <AvailableChallengesPage focusSlug={slug} />
}

export const Route = createFileRoute('/challenges/$slug')({ component: ChallengeSlugPage })
